export default __webpack_public_path__ + "static/media/clock_karma.820c9856.svg";